export const formatJobsFlyoutDuration = (durationToFormat: Date): string => {
  // split on periods to get rid of decimal seconds and other odd returns
  const holdDate = durationToFormat.toString().split('.');
  // as there will never be decimals of decimal seconds, we know that hours:minutes:seconds will always be in the second to last position
  return holdDate[holdDate.length - 2];
}
